import { createStore, applyMiddleware, compose } from 'redux';
import { History, MemoryHistory } from 'history';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'connected-react-router';
import createRootReducer from './rootReducer';

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const configureStore = (history: History | MemoryHistory) => {
  return createStore(
    createRootReducer(history),
    composeEnhancer(applyMiddleware(routerMiddleware(history), thunk)),
  );
};

export default configureStore;
